<template>
  <el-dialog :title="title" :visible.sync="visible" width="680px" append-to-body>
    <div v-loading="loading" class="user-detail-dialog">
      <div class="profile-header">
        <el-image v-if="detail.userPicture" class="avatar" :src="detail.userPicture" fit="cover"></el-image>
        <div v-else class="avatar placeholder">
          <i class="el-icon-user"></i>
        </div>
        <div class="profile-main">
          <div class="name-row">
            <span class="user-name">{{ detail.displayName || detail.name || detail.nickName || '--' }}</span>
            <el-tag size="mini" :type="detail.useridStatus == 1 ? 'danger' : 'success'">
              {{ detail.useridStatus == 1 ? '封号' : '正常' }}
            </el-tag>
            <el-tag v-if="detail.isVirtual" size="mini" type="info">虚拟用户</el-tag>
            <el-tag v-if="detail.isVip" size="mini" type="warning">会员</el-tag>
          </div>
          <div class="profile-text">{{ detail.profile || '暂无个性签名' }}</div>
        </div>
      </div>

      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="用户ID">{{ detail.userid || '--' }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ sexText(detail.sex) }}</el-descriptions-item>
        <el-descriptions-item label="等级">
          <el-image v-if="detail.gradeIcon" class="grade-icon" :src="detail.gradeIcon" fit="contain">
            <span slot="error" class="grade-fallback">{{ detail.gradeName || detail.grade || '--' }}</span>
          </el-image>
          <span v-else class="grade-fallback">{{ detail.gradeName || detail.grade || '--' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="城市">{{ detail.city || '--' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.mobile || '--' }}</el-descriptions-item>
        <el-descriptions-item label="余额">{{ detail.balance || 0 }}</el-descriptions-item>
        <el-descriptions-item label="可提现余额">{{ detail.availableBalance || 0 }}</el-descriptions-item>
        <el-descriptions-item label="积分">{{ detail.points || 0 }}</el-descriptions-item>
        <el-descriptions-item label="经验">{{ detail.experience || 0 }}</el-descriptions-item>
        <el-descriptions-item label="关注数">{{ detail.followNum || 0 }}</el-descriptions-item>
        <el-descriptions-item label="粉丝数">{{ detail.fanNum || 0 }}</el-descriptions-item>
        <el-descriptions-item label="加入圈子">{{ detail.joinCircleNum || 0 }}</el-descriptions-item>
        <el-descriptions-item label="发帖数量">{{ detail.postingVolume || 0 }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ detail.regTime || '--' }}</el-descriptions-item>
        <el-descriptions-item label="最近登录">{{ detail.loginTime || detail.enterTime || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
import { simpleListApi } from '@/api/user'

export default {
  name: 'UserDetailDialog',
  data() {
    return {
      visible: false,
      loading: false,
      title: '用户信息',
      detail: {}
    }
  },
  methods: {
    open(userId, fallback = {}) {
      this.visible = true
      this.loading = true
      this.detail = { ...fallback }
      if (!userId) {
        this.loading = false
        return
      }
      simpleListApi({ userId }).then(res => {
        if (res.code == 200 && res.data) {
          this.detail = res.data
        } else {
          this.$message.error(res.msg || '获取用户信息失败')
        }
      }).catch(err => {
        this.$message.error(err || '获取用户信息失败')
      }).finally(() => {
        this.loading = false
      })
    },
    sexText(sex) {
      return sex == 1 ? '男' : sex == 2 ? '女' : '未知'
    }
  }
}
</script>

<style scoped lang="scss">
.user-detail-dialog {
  min-height: 180px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
  padding: 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.avatar {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9eef3;
  color: #909399;
  font-size: 28px;
}

.profile-main {
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.profile-text {
  color: #606266;
  line-height: 1.6;
  word-break: break-word;
}

.grade-icon {
  display: block;
  width: 64px;
  height: 37px;
}

.grade-fallback {
  color: #606266;
  line-height: 37px;
}
</style>
